<script context="module" lang="ts">
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';
	import Program from '$lib/components/programs/Program.svelte';
	import icoAdd from 'iconoir/icons/plus-circle.svg';

	import getPermissions from '$lib/components/auth/getPermissions';

	async function canCreate() {
		return await getPermissions('create-program');
	}
</script>

<script lang="ts">
	/** @type {import('./$types').PageData} */
	export let data;

	const programs = data.programs;
</script>

<MetaTags
	title="Programs"
	desc="Whether your a tiny tot' or an adult - we have a range of programs for everybody."
/>

<Wrapper title="Programs">
	<div class="pt-8" />

	{#await canCreate()}
		<div />
	{:then result}
		{#if result == true}
			<div class="mb-4 w-fit rounded-full bg-zinc-900 px-4 py-1">
				<a href="/programs/create/">
					<p class="inline-block text-white">Add Program</p>
					<img
						class="inline-block w-6"
						src={icoAdd}
						alt="Add Program"
						style="filter: invert(94%) sepia(25%) saturate(0%) hue-rotate(354deg) brightness(103%) contrast(102%);"
					/>
				</a>
			</div>
		{/if}
	{/await}

	<div class="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-4">
		{#if programs.length == 0}
			<div class="rounded-md bg-white p-2 pb-4 drop-shadow-sm">
				<p class="text-center text-lg font-medium">No Programs Currently</p>
				<p class="pt-4 text-center">Check back later to browse all of our programs on offer.</p>
			</div>
		{/if}
		{#each programs as program}
			<Program
				title={program.programName}
				body={program.programSummary}
				image={program.programImage}
				imageFocal={program.programImageFocal}
				length={program.programLength}
				ages={program.programAges}
				id={program._id}
			/>
		{/each}
	</div>
</Wrapper>
